import { snackbarTypes } from '@/constants/alertTypes';
import alertsUtil from '@/util/alertsUtil';
import useExpTemplateList from '@experiment-details/hooks/template/useExpTemplateList';
import useRemoveExpDetailsTemplate from '@experiment-details/hooks/template/useRemoveExpDetailsTemplate';
import useSelectExpDetailsTemplate from '@experiment-details/hooks/template/useSelectExpDetailsTemplate';
import { DeleteViewModalProps } from '@shared/components/ViewSelect/modals/DeleteViewModal';
import { useState } from 'react';
import { useDispatch } from 'react-redux';

const useExpDetailsViewDelete = () => {
  const dispatch = useDispatch();
  const [modalOpened, setModalOpened] = useState(false);
  const [deleteId, setDeleteId] = useState('');

  const { data: templates = [] } = useExpTemplateList();
  const viewToDelete = templates.find(view => view.templateId === deleteId);
  const deleteTemplateMutation = useRemoveExpDetailsTemplate();
  const selectTemplate = useSelectExpDetailsTemplate();

  const onDeleteTemplate = (id: string) => {
    setDeleteId(id);
    setModalOpened(true);
  };

  const onClose = () => setModalOpened(false);

  const onConfirm = async () => {
    if (
      !viewToDelete ||
      !viewToDelete.templateId ||
      deleteTemplateMutation.isLoading
    )
      return;

    deleteTemplateMutation.mutate(
      {
        templateId: viewToDelete.templateId,
        projectId: viewToDelete.projectId
      },
      {
        onSuccess: () => {
          dispatch(
            alertsUtil.openSnackbarDialog(
              snackbarTypes.SUCCESS_API_RESPONSE,
              `View was successfully deleted`
            )
          );
          onClose();

          if (viewToDelete.defaultTemplate) {
            selectTemplate(null);
          }
        }
      }
    );
  };

  const deleteModalConfig: DeleteViewModalProps = {
    onConfirm,
    onClose,
    isOpened: modalOpened,
    name: viewToDelete?.templateName,
    isLoading: deleteTemplateMutation.isLoading
  };

  return {
    onDeleteTemplate,
    deleteModalConfig
  };
};

export default useExpDetailsViewDelete;
